<script setup>
import { computed, useTemplateRef } from "vue";
import PageLink from "@/Components/PageLink.vue";
import { cn } from "@/lib/utils.js";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  class: {
    type: String,
    required: false,
    default: "",
  },
  items: {
    type: Array,
    required: true,
  },
  refName: {
    type: String,
    required: false,
    default: "header-menu",
  },
  mobileMenuOpen: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const menuRef = useTemplateRef(props.refName);

defineExpose({
  menuRef,
});

const {
  props: {
    siteSettings: { login_page_route },
  },
} = usePage();

const loginUrl = computed(() => {
  return {
    type: "pages",
    href: login_page_route,
    title: "Member Login",
    target: "_self",
    external: false,
    anchor: false,
  };
});

const emit = defineEmits(["closeMobileMenu"]);
</script>

<template>
  <ul
    :id="refName"
    :ref="refName"
    :class="
      cn(
        'group !px-6 min-[1205px]:!pl-0 !list-none min-[1205px]:flex min-[1205px]:items-center min-[1205px]:justify-center min-[1205px]:gap-x-2 min-[1205px]:mx-auto min-[1205px]:z-0',
        props.class,
      )
    "
  >
    <li
      v-for="(item, index) in items"
      :key="index"
      class="border-b border-b-brand-dark-blue last:border-b-0 min-[1205px]:border-0 !m-0"
    >
      <PageLink
        :link="item.link"
        :show-arrow="false"
        :is-header-item="true"
        @pageLinkClicked="(event) => emit('closeMobileMenu', event)"
        class="px-0 min-[1205px]:w-auto hover:text-brand-blue whitespace-nowrap hover:!no-underline min-[1205px]:px-2 text-[20px]"
      >
        {{ item.link.title }}
      </PageLink>
    </li>
    <li
      v-if="loginUrl && mobileMenuOpen"
      class="border-b border-b-brand-dark-blue last:border-b-0 min-[1205px]:border-0 !m-0"
    >
      <PageLink
        :link="loginUrl"
        :show-arrow="false"
        class="px-0 min-[1205px]:w-auto min-[1205px]:px-2 text-[20px]"
        @pageLinkClicked="(event) => emit('closeMobileMenu', event)"
      >
        {{ loginUrl.title }}
      </PageLink>
    </li>
  </ul>
</template>

<style scoped></style>
